<template>
    <div class="step-indicator relative">
        <div class="progress-bar absolute">
            <div class="progress-bar-mask" v-bind:style="widthStyle"></div>
        </div>
        <div class="flex align-items-center justify-content-space-between">
            <div class="relative" v-for="n in stepNames.length" :key="n">
                <div class="step-indicator__circle margin-center text-align-center relative border-radius-50" :class="{'current': step >= n}">
                </div>
                <div class="step-indicator__label absolute text-align-center margin-t-16px font-size-16px font-gray-45 font-w-4" :class="{'font-blue-30': step >= n}">
                    <span class="step-indicator__inner-label relative">{{ stepNames[n-1] }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
export default {
    props: {
        step: Number,
        stepNames: Array,
    },

    created() {},

    computed: {
        progress() {
            return this.step >= this.stepNames.length ? 100 : (this.step - 1) * (100/(this.stepNames.length - 1)) || 0;
        },

        widthStyle() {
            return {
                width: `${this.progress}%`,
            };
        },
    },

    methods: {},
};
</script>